import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from 'vuex-persistedstate'

import storeContact from './storeContact'
import storeUser from './storeUser'
import storeSale from './storeSale'
import storePabx from './storePabx'
import storeMail from './storeMail'
import { BASE_URL } from '../service/ServiceURL'


let objectCombine = (...obj) => {
  return obj.reduce((prev, current) => Object.assign(prev, current), {})
}

Vue.use(Vuex)

let defaultMutation = {
  setBaseUrl: (state, url) => {
    state.baseUrl = url
  }
}

let defaultGetters = {
  hasIntegration: state => (state.pabx.name && state.user.pabx) ? true : false
}

let getters = objectCombine(
  defaultGetters,
  storePabx.getters,
  storeContact.getters,
  storeSale.getters,
  storeMail.getters
)

let mutations = objectCombine(
  defaultMutation,
  storeUser.mutations,
  storeSale.mutations,
  storePabx.mutations,
  storeContact.mutations,
  storeMail.mutations
)

export default new Vuex.Store({

  state: {
    baseUrl: BASE_URL,
    contact: storeContact.state,
    pabx: storePabx.state,
    user: storeUser.state,
    sale: storeSale.state,
    mail: storeMail.state
  },

  getters,

  mutations,

  plugins: [
    createPersistedState({
      key: 'rckt'
    })
  ]
})



// WEBPACK FOOTER //
// ./src/store/index.js